import { motion } from "framer-motion";
import { Award, ArrowUpRight } from "lucide-react";
import { certifications, accentTokens } from "../data/mock";

export const Certifications = () => {
  return (
    <section
      id="certifications"
      className="relative py-24 md:py-32"
      data-testid="certifications-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyan-300">
            // 05 — Certifications
          </p>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl font-bold tracking-tighter text-white">
            <span className="text-gradient-aurora animate-gradient-pan font-serif italic">
              Credentials.
            </span>
          </h2>
          <p className="mt-4 max-w-2xl text-cyan-50/70 text-base sm:text-lg leading-relaxed">
            Verified in 2025 — across AWS, IBM, and applied deep learning.
          </p>
        </motion.div>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {certifications.map((c, idx) => {
            const t = accentTokens[c.accent] || accentTokens.cyan;
            return (
              <motion.div
                key={c.name}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  duration: 0.5,
                  delay: idx * 0.05,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className={`group relative gradient-border rounded-2xl glass p-6 hover:-translate-y-1 transition-transform duration-300 ${t.glow}`}
                data-testid={`cert-card-${idx}`}
              >
                <div className={`absolute -top-8 -right-8 h-24 w-24 ${t.blob} blur-2xl rounded-full pointer-events-none`} />

                <div className="relative flex items-start gap-4">
                  <div className={`flex-shrink-0 inline-flex h-11 w-11 items-center justify-center rounded-xl glass-strong ${t.text}`}>
                    <Award className="h-4 w-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-display text-base sm:text-lg font-semibold text-white leading-tight">
                      {c.name}
                    </h3>
                    <p className="mt-1 text-sm text-cyan-50/70">{c.issuer}</p>
                  </div>
                  <span className={`font-mono text-xs px-2 py-0.5 rounded-full border ${t.chip} flex-shrink-0`}>
                    {c.year}
                  </span>
                </div>

                {c.credentialUrl ? (
                  <a
                    href={c.credentialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`relative mt-5 inline-flex items-center gap-1.5 text-sm font-medium ${t.text} hover:text-white transition-colors duration-200`}
                    data-testid={`cert-credential-${idx}`}
                  >
                    View Credential
                    <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                ) : (
                  <p className="relative mt-5 text-xs font-mono text-cyan-100/50">
                    Course certificate
                  </p>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
